import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AdminLayout from "../../../layouts/AdminLayout";
import Loader from "../../../components/loader";
import { adminPaths } from "../../../routes/admin";
import { fetchAdminDashboard } from "../../../redux/features/admin/actions/authAction";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading, dashboardData } = useSelector((state) => state.admin.auth);

  useEffect(() => {
    dispatch(fetchAdminDashboard());
  }, [dispatch]);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <AdminLayout>
        <div class="ct_px_40 ct_mt_40">
          <div class="ct_mb_30">
            <h4 class="mb-0 ct_fs_20  mb-2">Admin Overview</h4>
            <p class="ct_grey_text mb-0 ct_fs_14">
              Quick insight into what’s happening across the Nuvio platform
            </p>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-6 ct_mb_30">
              <div class="ct_outline_bg h-100">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_darkblue_text ct_mb_16">
                      Total Users
                    </p>
                    <h4 class="ct_fs_24 mb-0">
                      {dashboardData?.total_users ?? 0}
                    </h4>
                  </div>
                  <img src="../assets/img/dash_icon_1.png" alt="" />
                </div>
                <ul class="d-flex align-items-center gap-2 ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_orange_text">
                    <svg
                      width="23"
                      height="24"
                      viewBox="0 0 23 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32114)">
                        <path
                          d="M7.03156 16.2038L15.3574 8.03125"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32114">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(11.418 0.6875) rotate(45.5323)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    24%
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">
                    track all user types on Nuvio
                  </li>
                </ul>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ">
                  <a href="#" class="ct_yellow_link ct_fs_14">
                    View Report
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.3125L1.16732 6.3125M12.834 6.3125L7.83398 11.3125M12.834 6.3125L7.83398 1.3125"
                        stroke="#FFB703"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 ct_mb_30">
              <div class="ct_outline_bg h-100">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_darkblue_text ct_mb_16">
                      Active Projects
                    </p>
                    <h4 class="ct_fs_24 mb-0">
                      {dashboardData?.total_active_projects ?? 0}
                    </h4>
                  </div>
                  <img src="../assets/img/dash_icon_2.png" alt="" />
                </div>
                <ul class="d-flex align-items-center gap-2 ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_sky_blue_text">
                    38%
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32145)">
                        <path
                          d="M5.73231 8.00261L15.8359 13.8359"
                          stroke="#8ECAE6"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9.74891 15.7105L16.1237 14.0024L14.4156 7.6276"
                          stroke="#8ECAE6"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32145">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(21.8555 8.07031) rotate(120)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">live founder projects </li>
                </ul>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ">
                  <a href="#" class="ct_dark_blue_link ct_fs_14">
                    View Report
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                        stroke="#023047"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 ct_mb_30">
              <div class="ct_outline_bg h-100">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_darkblue_text ct_mb_16">
                      New Job Posts This Week{" "}
                    </p>
                    <h4 class="ct_fs_24 mb-0">
                      {dashboardData?.total_jobs_posted ?? 0}{" "}
                    </h4>
                  </div>
                  <img src="../assets/img/dash_icon_3.png" alt="" />
                </div>
                <ul class="d-flex align-items-center gap-2 ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_orange_text">
                    <svg
                      width="23"
                      height="24"
                      viewBox="0 0 23 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32114)">
                        <path
                          d="M7.03156 16.2038L15.3574 8.03125"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32114">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(11.418 0.6875) rotate(45.5323)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    24%
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">
                    fresh roles from enterprise
                  </li>
                </ul>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ">
                  <a href="#" class="ct_dark_blue_link ct_fs_14">
                    View Report
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                        stroke="#023047"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 ct_mb_30">
              <div class="ct_outline_bg h-100">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <p class="ct_fs_14 ct_darkblue_text ct_mb_16">Events </p>
                    <h4 class="ct_fs_24 mb-0">
                      {dashboardData?.total_events ?? 0}{" "}
                    </h4>
                  </div>
                  <img src="../assets/img/dash_icon_4.png" alt="" />
                </div>
                <ul class="d-flex align-items-center gap-2  ct_mt_16 pb-3">
                  <li class="ct_fs_12 ct_orange_text">
                    <svg
                      width="23"
                      height="24"
                      viewBox="0 0 23 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1696_32114)">
                        <path
                          d="M7.03156 16.2038L15.3574 8.03125"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                          stroke="#FB8500"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1696_32114">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(11.418 0.6875) rotate(45.5323)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    24%
                  </li>
                  <li class="ct_text_op_2">|</li>
                  <li class="ct_grey_text ct_fs_12">pending moderation</li>
                </ul>
                <div class="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ">
                  <a href="#" class="ct_dark_blue_link ct_fs_14">
                    View Report
                  </a>
                  <a href="#">
                    <svg
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                        stroke="#023047"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xxl-5 col-xl-5 mb-4">
              <div class="ct_outline_bg h-100">
                <div class="d-flex align-items-center justify-content-between gap-2">
                  <div>
                    <h4 class="ct_fs_22 mb-2">Activity</h4>
                    <p class="ct_text_clr_acacac ct_fs_14">Platform report</p>
                  </div>
                  <div className="position-relative">
                    <select class="form-control ct_input ct_fit_content  ct_border_radius_10 pe-5 ct_border_color_E7E7E7 ct_text_clr_7E7E7E">
                      <option value="">Monthly</option>
                    </select>
                    <i class="fa-solid fa-angle-down ct_show_eye ct_text_clr_7E7E7E ct_pointer_events_none"></i>
                  </div>
                </div>
                <div id="chart"></div>
              </div>
            </div>
            <div class="col-xxl-5 col-xl-4 mb-4">
              <div class="ct_outline_bg h-100">
                <h4 class="ct_fs_20 mb-3">Shortcut</h4>
                <ul class="ct_shortcut_list_admin">
                  <li>
                    <div>
                      <p class=" ct_fs_16 ct_text_clr_757886 mb-1">
                        Review Pending Submissions
                      </p>
                      <ul>
                        <li class="ct_fs_14 ct_text_clr_757886">20 reviews</li>
                        <li>
                          <span class="ct_dot_5"></span>
                        </li>
                        <li class="ct_fs_14">Go to Review Panel</li>
                      </ul>
                    </div>
                    <a href="#" class="text-dark">
                      <i class="fa-solid fa-arrow-right"></i>
                    </a>
                  </li>
                  <li class="ct_border_top_light ct_mt_16 ct_pt_16">
                    <div>
                      <p class="ct_text_clr_757886 mb-1">Send Announcement</p>
                      <ul>
                        <li class="ct_fs_14 ct_text_clr_757886">All Users </li>
                        <li>
                          <span class="ct_dot_5"></span>
                        </li>
                        <li class="ct_fs_14">Compose Message</li>
                      </ul>
                    </div>
                    <a href="#" class="text-dark">
                      <i class="fa-solid fa-arrow-right"></i>
                    </a>
                  </li>
                  <li class="ct_border_top_light ct_mt_16 ct_pt_16">
                    <div>
                      <p class="ct_text_clr_757886 mb-1">Moderate Reports</p>
                      <ul>
                        <li class="ct_fs_14 ct_text_clr_757886">32 Flagged </li>
                        <li>
                          <span class="ct_dot_5"></span>
                        </li>
                        <li class="ct_fs_14">View Flagged Items</li>
                      </ul>
                    </div>
                    <a href="#" class="text-dark">
                      <i class="fa-solid fa-arrow-right"></i>
                    </a>
                  </li>
                  <li class="ct_border_top_light ct_mt_16 ct_pt_16">
                    <div>
                      <p class="ct_text_clr_757886 mb-1">Download Reports</p>
                      <ul>
                        <li class="ct_fs_14 ct_text_clr_757886">All Users </li>
                        <li>
                          <span class="ct_dot_5"></span>
                        </li>
                        <li class="ct_fs_14">Go to Reports</li>
                      </ul>
                    </div>
                    <a href="#" class="text-dark">
                      <i class="fa-solid fa-arrow-right"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xxl-2 col-xl-3 mb-4">
              <div class="ct_outline_bg h-100">
                <h4 class="ct_fs_20  mb-3">Job Seekers</h4>
                <div id="ct_Job_Seekers"></div>
                <div class="session-stats">
                  <div class="d-flex align-items-start">
                    <span
                      class="booked-dot"
                      style={{ backgroundColor: "#FB8500" }}
                    ></span>
                    <div>
                      <h6 class="ct_fs_24 mb-1">1062</h6>
                      <p class="mb-0 ct_grey_text">Active</p>
                    </div>
                  </div>
                  <div class="d-flex align-items-start">
                    <span
                      class="completed-dot"
                      style={{
                        backgroundColor: "hwb(31.79deg 0% 1.57% / 19%)",
                      }}
                    ></span>
                    <div>
                      <h6 class="ct_fs_24 mb-1">188</h6>
                      <p class="mb-0 ct_grey_text">Inactive</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xxl-4 mb-4">
              <div class="ct_outline_bg h-100">
                <h4 class="mb-0 ct_fs_20 mb-3">System Logs</h4>
                <ul class="ct_shortcut_list_admin">
                  <li>
                    <div>
                      <p class=" ct_fs_16 ct_text_clr_757886 mb-1">
                        Last Login
                      </p>
                      <ul>
                        <li class="ct_fs_14 ct_text_clr_757886">
                          Today at 10:54 AM{" "}
                        </li>
                        <li>
                          <span class="ct_dot_5"></span>
                        </li>
                        <li class="ct_fs_14">Login Activity</li>
                      </ul>
                    </div>
                    <a href="#" class="text-dark">
                      <i class="fa-solid fa-arrow-right"></i>
                    </a>
                  </li>
                  <li class="ct_border_top_light ct_mt_16 ct_pt_16">
                    <div>
                      <p class="ct_text_clr_757886 mb-1">
                        Alex Approved Workshop
                      </p>
                      <ul>
                        <li class="ct_fs_14 ct_text_clr_757886">3 Workshops</li>
                        <li>
                          <span class="ct_dot_5"></span>
                        </li>
                        <li class="ct_fs_14">20-08-2025</li>
                      </ul>
                    </div>
                    <a href="#" class="text-dark">
                      <i class="fa-solid fa-arrow-right"></i>
                    </a>
                  </li>
                  <li class="ct_border_top_light ct_mt_16 ct_pt_16">
                    <div>
                      <p class="ct_text_clr_757886 mb-1">Moderate Reports</p>
                      <ul>
                        <li class="ct_fs_14 ct_text_clr_757886">32 Flagged </li>
                        <li>
                          <span class="ct_dot_5"></span>
                        </li>
                        <li class="ct_fs_14">View Flagged Items</li>
                      </ul>
                    </div>
                    <a href="#" class="text-dark">
                      <i class="fa-solid fa-arrow-right"></i>
                    </a>
                  </li>
                  <li class="ct_border_top_light ct_mt_16 ct_pt_16">
                    <div>
                      <p class="ct_text_clr_757886 mb-1">Download Reports</p>
                      <ul>
                        <li class="ct_fs_14 ct_text_clr_757886">All Users </li>
                        <li>
                          <span class="ct_dot_5"></span>
                        </li>
                        <li class="ct_fs_14">Go to Reports</li>
                      </ul>
                    </div>
                    <a href="#" class="text-dark">
                      <i class="fa-solid fa-arrow-right"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xxl-8 mb-4">
              <div class="row">
                <div class="col-xl-4 mb-4 col-lg-4">
                  <div class="ct_outline_bg h-100">
                    <h4 class="ct_fs_20 ">Coaches</h4>
                    <div id="ct_prospects_chart"></div>
                    <div class="session-stats">
                      <div class="d-flex align-items-start">
                        <span
                          class="booked-dot"
                          style={{ backgroundColor: "#FB8500;" }}
                        ></span>
                        <div>
                          <h6 class="ct_fs_24 mb-1">1062</h6>
                          <p class="mb-0 ct_grey_text">Active</p>
                        </div>
                      </div>
                      <div class="d-flex align-items-start">
                        <span
                          class="completed-dot"
                          style={{
                            backgroundColor: "hwb(31.79deg 0% 1.57% / 19%)",
                          }}
                        ></span>
                        <div>
                          <h6 class="ct_fs_24 mb-1">8</h6>
                          <p class="mb-0 ct_grey_text">Inactive</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 mb-4 col-lg-4">
                  <div class="ct_outline_bg h-100">
                    <h4 class="ct_fs_20  ">Enterprises </h4>
                    <div id="ct_event_chart"></div>
                    <div class="session-stats">
                      <div class="d-flex align-items-start">
                        <span
                          class="booked-dot"
                          style={{ backgroundColor: "#8ECAE6" }}
                        ></span>
                        <div>
                          <h6 class="ct_fs_24 mb-1">2</h6>
                          <p class="mb-0 ct_grey_text">Active</p>
                        </div>
                      </div>
                      <div class="d-flex align-items-start">
                        <span
                          class="completed-dot"
                          style={{
                            backgroundColor:
                              "hsl(199.09deg 63.77% 72.94% / 21%)",
                          }}
                        ></span>
                        <div>
                          <h6 class="ct_fs_24 mb-1">5</h6>
                          <p class="mb-0 ct_grey_text">Inactive</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 mb-4 col-lg-4">
                  <div class="d-flex align-items-center justify-content-between gap-2 ct_orange_card_234 ct_p_28_20">
                    <div>
                      <h3
                        class="ct_fs_30 text-white ct_cursor_pointer"
                        onClick={() => navigate(adminPaths?.NewUserSignup)}
                      >
                        150 Sign-Ups
                      </h3>
                      <p
                        class="ct_fs_12 text-white"
                        style={{ maxWidth: "207px" }}
                      >
                        There has been 150 new sign-ups this past few weeks
                      </p>
                    </div>
                    <div>
                      <a
                        href="#"
                        class="text-white"
                        onClick={() => navigate(adminPaths?.NewUserSignup)}
                      >
                        <i class="fa-solid fa-angle-right"></i>
                      </a>
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-between gap-2 ct_blue_card_234 mt-3 p-4">
                    <div>
                      <h3
                        class="ct_fs_30 text-white ct_cursor_pointer"
                        onClick={() =>
                          navigate(adminPaths?.AdPerformanceSnapshot)
                        }
                        style={{ maxWidth: "180px" }}
                      >
                        Manage Ads
                      </h3>
                      <p
                        class="ct_fs_12 text-white"
                        style={{ maxWidth: "207px" }}
                      >
                        Control what shows up across Nuvio pages
                      </p>
                    </div>
                    <a
                      href="#"
                      class="text-white"
                      onClick={() =>
                        navigate(adminPaths?.AdPerformanceSnapshot)
                      }
                    >
                      <i class="fa-solid fa-angle-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AdminLayout>
    </div>
  );
};

export default Dashboard;
